import { Injectable } from '@angular/core';

import { Deserialize } from './decorators';
import { Resource, ResourceService } from './resource';
import { Session } from './session';
import { RetakeDocumentPayload } from '../interfaces/retake-document-payload.interface';

export class RetakeRequest extends Resource {
  @Deserialize((v) => v && new Date(v))
  retakenAt: Date;

  facePhoto: boolean;
  idPhoto: boolean;
  facePhotoReason: string;
  idPhotoReason: string;

  get isFullRequest(): boolean {
    return this.facePhoto && this.idPhoto;
  }

  calcWaitTime(): number {
    if (this.$resolved) {
      const baseTime = (this.retakenAt || this.createdAt).getTime();

      return Date.now() - baseTime;
    }

    return 0;
  }
}

@Injectable({ providedIn: 'root' })
export class RetakeRequests extends ResourceService<RetakeRequest> {
  constructor() {
    super();

    this.base = 'retake_requests';
    this.ctor = RetakeRequest;
  }

  async create(session: Session, reason: RetakeDocumentPayload): Promise<Session> {
    /// Some sanitizing from camelCase to snake_case
    const attributes = {
      retake_request: {
        session_id: session.id,
        face_photo: reason.facePhoto,
        id_photo: reason.idPhoto,
        face_photo_reason: reason.facePhotoReason,
        id_photo_reason: reason.idPhotoReason
      }
    };

    this.base = `sessions/${session.token}/retake_requests`;

    return this.$create(attributes)
      .asPromise()
      .then(() => {
        session.$refresh();
        return session.asPromise();
      });
  }

  async update(session: Session) {
    this.base = `sessions/${session.token}/retake_requests`;

    return this.$save(session.retakeRequest).then((retakeRequest) => retakeRequest.asPromise());
  }
}
